import { Service } from "@angular/core";

import { Submenu } from "@/shared-module/models";

@Service()
export class UrlService {
  knownRoots = ["/cvcoriginal", "/cvcevo", "/cvclight", "/fof", "/tca", "/hcc", "/sustainability", "/gl"];

  constructor() {}

  getKnownRoots(): string[] {
    return this.knownRoots;
  }

  parseUrl(url: string, data: Submenu, removeKnownUrl: boolean = false): any {
    let page: string;
    let path: string;
    let subpath: string;

    let location = this.getUrlPath(url);
    let root = "";
    this.knownRoots.forEach((r) => {
      if (location.startsWith(r)) {
        root = r;
      }
    });

    if (root && removeKnownUrl) {
      location = location.replace(root, "");
    }

    if (location) {
      const splitted = location.split("/");
      page = splitted[1];
      if (splitted.length >= 4) {
        path = splitted[2];
        subpath = splitted[3];
      } else if (splitted.length >= 3) {
        path = splitted[2];
        subpath = "";
      } else if (data && data.items.length > 0) {
        path = data.items[0].value;
        subpath = "";
      }
    }

    return {
      page,
      path,
      subpath,
    };
  }

  getUrlParams(queryString) {
    // remove any preceding url and split
    queryString = queryString
      .substring(queryString.indexOf("?") + 1)
      .split("&");
    const params = {};
    let pair = null;
    const d = decodeURIComponent;
    // march and parse
    for (let i = queryString.length - 1; i >= 0; i--) {
      pair = queryString[i].split("=");
      params[d(pair[0])] = d(pair[1] || "");
    }

    return params;
  }

  getUrlPath(search) {
    if (search.indexOf("?") > 0) {
      return search.substring(0, search.indexOf("?"));
    }
    return search;
  }
}
